import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DefenseProblem = () => {
  const challenges = [
    'High-stakes operational demands',
    'Complex, evolving protocols',
    'Inter-agency coordination challenges',
    'Strict compliance requirements',
    'Limited time for role-specific training'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Defense and Government Contractors <span className="text-cyan-400">Face:</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="space-y-4">
            {challenges.map((challenge, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{challenge}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain delivers the enablement layer defense-aligned teams need to operate with clarity, precision, and confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DefenseProblem;
